const HIDDEN_INTEGRATION_NAMES = new Set([
  'core api',
  'sftp intake',
  'webhook dispatch',
  'partner feed',
]);

/** Keep the integration-health API call, and only render the working connector. */
export function visibleIntegrationConnectors(items) {
  return (items || []).filter((item) => {
    const name = String(item?.name || '').trim().toLowerCase();
    return !HIDDEN_INTEGRATION_NAMES.has(name);
  });
}
